<template>
    <div class="message" @click="$emit('click-user')">
        <img class="profile-img circle" :src="usr.img"/>
        <div class="msgtext">
            <div>
                <span class="dt">{{ msg.dt | formatDate }}</span>
                <span class="name">{{ usr.first + ' ' + usr.last || msg.name || msg.email }}</span>
            </div>
            <span class="text">{{ msg.text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Message',
    props: ['usr', 'msg'],
}
</script>

<style lang="scss" scoped>

.message {
    padding: 10px;
    border-radius: 8px;
    overflow: auto;
    opacity: 1;
    max-height: 400px;
    margin-bottom: 10px;
    background-color: rgba(0,0,0,0.4);
    backdrop-filter: blur(20px);
    cursor: pointer;
    transition: all 0.3s ease;
    transition-property: background-color color;

    pointer-events: initial;

    &:hover {
        background-color: white;
        color: black;
        .msgtext .dt {
            color: gray;
        }
        .profile-img {
            box-shadow: 0 0 0 4px var(--main-color);
        }
    }

    .profile-img {
        position: relative;
        float: right;
        margin-left: 10px;
        background-color: white;
        width: 50px;
        height: 50px;
        transition: box-shadow 0.2s ease;
    }
}
.msgtext {
    span {
        text-align: left;
        display: block;
    }
    .text {
        font-weight: normal;
        overflow-wrap: break-word;
        word-wrap: break-word;
        -webkit-hyphens: manual;
        -ms-hyphens: manual;
        -moz-hyphens: manual;
        hyphens: manual;
    }
    .dt {
        transition: color 0.3s ease;
        color: rgba(255, 255, 255, 0.6);
        font-size: 11px;
        padding-top: 2px;
        margin-bottom: 1px;
        text-align: right;
        float: right;
    }
    .name {
        width: max-content;
    }
    .org {
        font-weight: normal;
    }
}
</style>